import React, { useEffect, useState, Suspense } from 'react';

const MIN_LOADING_TIME = 500; // milissegundos

const DelayedSuspense = ({ children, fallback }) => {
  const [showFallback, setShowFallback] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => setShowFallback(false), MIN_LOADING_TIME);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <Suspense fallback={fallback}>
      {showFallback ? fallback : children}
    </Suspense>
  );
};

export default DelayedSuspense;
